import Http from '@/services/http';
import store from '@/store';
import env from '@/env';
import { getToken, getMessageByCode } from '@/services/utils';
import bus from '@/utils/mitt.js';
export let controllerNlp;
export let controllerTts;
// 获取举报类型
export const getProjectStatusList = params => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/project/getProjectStatusList',
    params,
    method: 'get'
  });
};
/*
投诉、撤销投诉、点赞
id
complaintText 投诉内容
complaintType 投诉类型：1答非所问 2回答有误 3信息过时 4没有帮助 5存在偏见 6内容违法 注意：多个数据英文逗号拼接
complaintStatus 投诉状态：0取消投诉 1点赞 2投诉
*/
export const updateComplaintStatus = params => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/authority/item/updateComplaintStatus',
    params,
    method: 'post'
  });
};
/*
{
    "macId": "string",
    "content": "string",
    "roleId": 0,
    "type": 0
}
*/
export const saveChatMessage = (params, cb) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/authority/item/saveMacChatMessage',
    params,
    method: 'post'
  });
};
/*
{
    "macId": "string",
    "roleId": 0,
}
*/
export const getChatMessage = (params, cb) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/authority/item/getMacChatMessage/${params.macId}/${params.roleId}`,
    params,
    method: 'get'
  });
};
/*
session列表
{
    page: 页码,
    limit: 条数
}
*/
export const getMacChatMessagePageList = params => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/authority/item/getMacChatMessagePageList/${params.macId}/${params.roleId}`,
    params,
    method: 'get'
  });
};
/*
删除session
*/
export const deleteSession = params => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/authority/item/deleteSession/${params.session}/${params.roleId}`,
    params,
    method: 'delete'
  });
};
/*
{
    page: 页码,
    limit: 条数
}
*/
export const getMacChatMessageWithUuid = params => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/authority/item/getMacChatMessage/${params.roleId}/${params.sort}/${params.uuid}`,
    params,
    method: 'get'
  });
};
/*
任务列表
{
  page:
  limit
}
*/
export const getTaskList = params => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/task/open/api/getMacChatMessagePageList`,
    params,
    method: 'get'
  });
};
/*
重新创建任务
{
  taskId
}
*/
export const reCreatTask = params => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/task/open/api/createTask/${params.taskId}`,
    params,
    method: 'post'
  });
};
/*
删除任务
{
  taskId
}
*/
export const deleteTask = params => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/task/open/api/deleteTask/${params.taskId}`,
    params,
    method: 'delete'
  });
};
export const chatgptTalk = params => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/faq/authority/item/sendNlpFaq',
    params,
    method: 'post'
  });
};
// 返回查询页码数据
export const getNlpGetQaRetrivalInfo = params => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/authority/item/nlpGetQaRetrivalInfo',
    params,
    method: 'post',
    errorMessageAlert: false
  });
};
export const chatgptTalkStream = (data, cb, cbText) => {
  const url = env.APIHOST;
  controllerNlp = new AbortController();
  const signal = controllerNlp.signal;
  fetch(`${url}/copilot/v1/authority/item/sendNlpStream`,
  // `/cwhCopilot/copilot/p1/authority/item/sendNlpStream`,
  {
    signal,
    method: 'post',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  }).then(async response => {
    if (response.status != 200) {
      cbText('', -1);
      getMessageByCode(response.status);
      return;
    }
    const contentType = response.headers.get('Content-Type') || '';
    if (contentType.includes('application/json')) {
      cbText('', -1);
      bus.emit('flvEnd', true);
      try {
        const res = await response.json();
        getMessageByCode(res.code, res.msg);
      } catch (error) {
        ElMessage({
          type: 'error',
          showClose: true,
          duration: 5000,
          message: '当前系统异常，请联系管理员'
        });
      }
      return;
    }
    const answerType = response.headers.get('X-Custom-Type');
    if (answerType && answerType != 'txt') {
      if (answerType == 'image') {
        const reTxt = `好的，已给您创建${answerType == 'image' ? '生图' : '语音生成'}任务，请稍后查看。`;
        cbText(reTxt, true);
        cb(reTxt, true);
        setTimeout(() => {
          store.commit('role/setShowRightSlide', true);
        }, 2000);
      } else {
        cbText('该技能稍后推出', true);
        cb('该技能稍后推出', true);
      }
      return;
    }
    // const response2 = response.clone();
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let allValue = '';
    reader.read().then(async function processText({
      done,
      value
    }) {
      if (done) {
        if (allValue == '\n') {
          cbText('', -1);
          bus.emit('flvEnd', true);
          ElMessage({
            type: 'error',
            showClose: true,
            duration: 5000,
            message: '当前系统异常，请联系管理员'
          });
        } else {
          cbText('', done);
        }
        cb(allValue, done);
        return;
      }
      try {
        const curText = decoder.decode(value, {
          stream: true
        });
        allValue += curText;
        cbText(curText, done);
        cb(allValue, done);
      } catch (e) {}
      return reader.read().then(processText);
    });
  }).catch(err => {
    // bus.emit('flvEnd', true)
    console.log(err, 'sendNlpStream');
    // const r = err?.response
    // const status = r.status
    // getMessageByCode(status)
  });
};

export const streamSpeaker = async (data, c) => {
  return new Promise((r, j) => {
    controllerTts = new AbortController();
    const signal = controllerTts.signal;
    data.selectWord = data.selectWord.replace(/(\d{1,3})(,\d{3})*千元/g, str => {
      return str.replace(' ', '').replace(',', '').replace('千', '000');
    });
    data.selectWord = data.selectWord.replace(/(([1-9]\d*\.?\d*)|(0\.\d*[1-9]))百万元/g, str => {
      console.log(str, 123);
      const arr = str.split('百万');
      return parseFloat(arr[0]) * 1000000 + '元';
    });
    fetch(`/api/streaming?product=copilot&ignore_limit=true&audio_type=pcm&speaker=${data.speaker}&text=${data.selectWord}&speed=1.0&volume=1.0&rate=16000`,
    // ,{
    //   method: 'post',
    //   body: `product=copilot&ignore_limit=true&audio_type=pcm&speaker=${data.speaker}&text=${data.selectWord}&speed=1.0&volume=1.0&rate=16000`,
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    //   }
    // },
    {
      signal
    })
    // Retrieve its body as ReadableStream
    .then(response => {
      const reader = response.body.getReader();
      reader.read().then(function processText({
        done,
        value
      }) {
        if (done) {
          c(value, done);
          console.log('Stream done.');
          r(done);
          return;
        }
        try {
          // console.log('Stream get.', value)
          c(value);
        } catch (e) {
          // Doesn't need to be reported, because partial JSON result will be parsed next time around (from buffer).
          //console.log("EXCEPTION:"+e);
        }
        return reader.read().then(processText);
      });
    }).catch(err => {
      // bus.emit('flvEnd', true)
      console.log(err);
    });
  });
};
export const synSpeaker = async (data, c) => {
  return new Promise((r, j) => {
    fetch(`/api/synthesis?audio_type=pcm&speaker=${data.speaker}&text=${data.selectWord}&speed=1.0&volume=1.0&rate=16000`).then(res => {
      return res.arrayBuffer();
    }).then(res => {
      c && c(res);
      r(res);
    });
  });
};
export const streamSpeakerNolimit = async (data, c) => {
  return new Promise((r, j) => {
    controllerTts = new AbortController();
    const signal = controllerTts.signal;
    fetch(`/api/streaming`, {
      signal,
      method: 'post',
      body: `product=copilot&ignore_limit=true&audio_type=pcm&speaker=${data.speaker}&text=${data.selectWord}&speed=1.0&volume=1.0&rate=16000`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(response => {
      const reader = response.body.getReader();
      reader.read().then(function processText({
        done,
        value
      }) {
        if (done) {
          c(value, done);
          console.log('Stream done.');
          r(done);
          return;
        }
        try {
          c(value);
        } catch (e) {
          // Doesn't need to be reported, because partial JSON result will be parsed next time around (from buffer).
          //console.log("EXCEPTION:"+e);
        }
        return reader.read().then(processText);
      });
    }).catch(err => {
      // bus.emit('flvEnd', true)
      console.log(err);
    });
  });
};